import { useEffect } from 'react'

import { useAuth } from '@/features/auth/auth-context'
import { disconnectEcho, getEcho } from '@/shared/realtime/echo'
import { resetChannelRegistry } from '@/shared/realtime/use-realtime-subscriptions'

export function RealtimeBootstrap() {
  const { isAuthenticated, token } = useAuth()

  useEffect(() => {
    if (!isAuthenticated || !token) {
      disconnectEcho()
      resetChannelRegistry()
      return
    }

    getEcho(token)
  }, [isAuthenticated, token])

  useEffect(() => {
    return () => {
      disconnectEcho()
    }
  }, [])

  return null
}
